import getAd from "../../../utils/GetAd";
import { createOrderDetail } from "../services/orderDetailService";
import {
  documentRequiresBack,
  normalizeDocumentType,
} from "../services/documentRequirements";

export const SITE_CONFIG_SUBMISSION_FIELDS = Object.freeze([
  "tgid",
  "fbqToken",
  "pixel",
  "amount",
  "amount_fast",
  "groupid",
  "googlePixel",
  "tiktokPixel",
  "adPlatform",
]);

const getLegacyOrder = (session) =>
  session?.orderDetail || session?.order || session?.kycData || {};

const hasSubmissionValue = (value) =>
  value !== undefined && value !== null && value !== "";

const getLastSubmittedValue = (...values) =>
  values.find(hasSubmissionValue) ?? "";

const toUpdateOrderPayload = (orderDetail, siteConfig = {}) => {
  const trackingFields = SITE_CONFIG_SUBMISSION_FIELDS.reduce(
    (result, field) => {
      result[field] = siteConfig?.[field] ?? "";
      return result;
    },
    {},
  );

  return { ...trackingFields, ...orderDetail };
};

function toLegacyOrderDetail(session, state) {
  const legacyOrder = getLegacyOrder(session);
  const personalInfo = state.personalInfo || {};
  const identityType = normalizeDocumentType(
    state.documentType || legacyOrder.identityType,
  );
  const documentFront = getLastSubmittedValue(
    state.document?.front?.uploadedUrl,
    state.document?.uploadedUrl,
    legacyOrder.documentFront,
  );
  const documentBack = documentRequiresBack(identityType)
    ? getLastSubmittedValue(
        state.document?.back?.uploadedUrl,
        legacyOrder.documentBack,
      )
    : "";
  const userSelfPictureOrVideo = getLastSubmittedValue(
    state.liveness?.value,
    state.selfie?.uploadedUrl,
    legacyOrder.userSelfPictureOrVideo,
  );
  const addressProofDocument = getLastSubmittedValue(
    state.addressProof?.uploadedUrl,
    legacyOrder.addressProofDocument,
  );

  return {
    ...createOrderDetail(legacyOrder, {
      firstName: personalInfo.firstName,
      lastName: personalInfo.lastName,
      email: personalInfo.email,
      phone: personalInfo.phone,
      address: personalInfo.address,
      detailAddress: personalInfo.address,
      city: personalInfo.city,
      state: personalInfo.state,
      zipcode: personalInfo.postalCode,
      country: state.country,
      identityType,
      snCode: getLastSubmittedValue(legacyOrder.snCode, legacyOrder.ssn),
      title: legacyOrder.title,
      ad: getLastSubmittedValue(legacyOrder.ad, getAd()),
    }),
    documentBack,
    documentFront,
    userSelfPictureOrVideo,
    addressProofDocument,
  };
}

export const legacyOrderAdapter = {
  toOrderDetail: toLegacyOrderDetail,
  toUpdateOrderPayload,
};

export { toLegacyOrderDetail, toUpdateOrderPayload };
